// extracted by mini-css-extract-plugin
export default {"List":"OnUu_HQPzaflmJSYiU4l","ListEmpty":"W6CoXCD1fABeX0oYwRzs","Users":"eMizjSw5ao80Bpaifrfv","EmptyText":"qs00h6XXMYFX8v7STwlC"};